export default __webpack_public_path__ + "static/media/thailand_powerline_distribution.1859a909.png";